import React from 'react';

import { AvatarProps } from './avatar.types';
import * as S from './avatar.styles';

function getInitials(name: string) {
  return name
    .split(' ')
    .map((x) => x.charAt(0).toUpperCase())
    .join('');
}

function getBackgroundColor(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    colour += ('00' + value.toString(16)).slice(-2);
  }
  return colour;
}

export const Avatar: React.FC<AvatarProps> = ({ size, user }) => {
  const name = user.name ? user.name : 'Default Name';
  return (
    <S.Container $backgroundColor={getBackgroundColor(name)} $size={size}>
      {user.photoUrl ? <S.Image src={user.photoUrl} /> : getInitials(name)}
    </S.Container>
  );
};
